import { createStore, applyMiddleware, compose } from 'redux'
// import { offline } from '@redux-offline/redux-offline'
// import offlineConfig from '@redux-offline/redux-offline/lib/defaults'

import { routerMiddleware } from 'react-router-redux'
import thunk from 'redux-thunk'
import createHistory from 'history/createBrowserHistory'
import rootReducer from './modules'
// eslint-disable-next-line
import { save, load } from "redux-localstorage-simple"

export const history = createHistory()

const enhancers = []
const middleware = [
  thunk,
  routerMiddleware(history),
  save()
]

if (process.env.NODE_ENV === 'development') {
  const devToolsExtension = window.__REDUX_DEVTOOLS_EXTENSION__

  if (typeof devToolsExtension === 'function') {
    enhancers.push(devToolsExtension())
  }
}

const composedEnhancers = compose(
  applyMiddleware(...middleware),
  // offline(offlineConfig),
  ...enhancers
)

const initialState = load()



// Don't show login screen if there's already a user on load
if (initialState) {
  initialState.showWelcomeBack = initialState.showWelcomeBackOnReturn
  initialState.showOptinText = !initialState.optIn
}

const store = createStore(
  rootReducer,
  initialState,
  composedEnhancers
)

export default store



// WEBPACK FOOTER //
// ./src/store.js